import Instance from "../../../../Axios";

// New Actions for the app

const GetCredPortariaAcesso = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/portariaAcesso`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_PORTARIA_ACESSO",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredPortariaAcesso;